import { ROUTES, YT_ACADEMIA_MATRITENSE_URL } from '@/constants';

export const sidebarItems = [
	{ label: 'Historia', to: ROUTES.ACADEMIA_MATRITENSE_HISTORIA },
	{ label: 'Programación Académica', to: ROUTES.ACADEMIA_MATRITENSE_PROGRAMACION_ACADEMICA },
	{ label: 'Hemeroteca', to: ROUTES.ACADEMIA_MATRITENSE_HEMEROTECA },
	{ label: 'Catálogo', to: ROUTES.ACADEMIA_MATRITENSE_CATALOGO, matchDescendants: true },
	{ label: 'Canal de YouTube', to: YT_ACADEMIA_MATRITENSE_URL },
];
